export let globalNavigateFn = null;

export const setGlobalNavigate = (fn) => {
  globalNavigateFn = fn;
};

export const navigate = (path) => {
  if (globalNavigateFn) {
    globalNavigateFn(path);
  } else {
    window.location.href = path;
  }
};
